(function() {
  var wrap    = document.getElementById('blog-feedback');
  var title   = document.getElementById('blog-feedback-title');
  var buttons = document.getElementById('blog-feedback-buttons');
  if(!wrap)
    return;
  wrap.querySelectorAll('.blog-feedback-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var postId = wrap.dataset.postId;
      var href   = ui.url.blogfeedback;
      var val    = this.dataset.value;
      buttons.querySelectorAll('button').forEach(function(b) { b.disabled = true; });
      var fd = new FormData();
      fd.append('post_id',     postId);
      fd.append('is_positive', val);
      fetch(href, { method: 'POST', body: fd })
        .then(function(r) { return r.json(); })
        .then(function(json) {
          buttons.style.display = 'none';
          title.textContent = json.message || '';
        })
        .catch(function() {
          buttons.querySelectorAll('button').forEach(function(b) { b.disabled = false; });
        });
    });
  });
})();

(function() {
var _ = ui._;
ui.youtubeShow        = youtubeShow;

  var article = document.querySelector('.blog-post-description');
  var tocList = document.getElementById('blog-toc');
  var tocWrap = document.getElementById('blog-toc-wrap');

  if (article) {
    article.querySelectorAll('table:not(.stats)').forEach(function(table) {
      if (table.parentNode && table.parentNode.classList.contains('blog-table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'blog-table-scroll';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  if (article && tocList && tocWrap) {
    var headings = article.querySelectorAll('h2, h3');
    if (headings.length) {
      var pad = function(n) { return n < 10 ? '0' + n : '' + n; };

      var tocHeadings = [];
      headings.forEach(function(h, i) {
        var uEl = h.querySelector('u');
        var label = (uEl ? uEl.textContent.trim() : h.textContent);
        if(!label)
          return;
        if(!h.id)
          h.id = 'section-' + (i + 1);
        tocHeadings.push(h);

        var a = document.createElement('span');
        a.dataset.toc = h.id;
        a.className = 'flex gap-3 transition-colors';
        a.addEventListener('click', move);

        var numSpan = document.createElement('span');
        numSpan.className = 'text-zinc-400';
        numSpan.textContent = pad(tocHeadings.length) + '.';

        var labelSpan = document.createElement('span');
        labelSpan.className = 'uppercase italic text-zinc-400 hover:text-black transition-colors';
        labelSpan.textContent = label;

        a.appendChild(numSpan);
        a.appendChild(labelSpan);
        tocList.appendChild(a);
      });

      if (tocHeadings.length) tocWrap.hidden = false;

      var links = tocList.querySelectorAll('[data-toc]');

      var setActive = function(id) {
        links.forEach(function(l) {
          var active = l.dataset.toc === id;
          var num = l.children[0];
          var lab = l.children[1];
          num.classList.toggle('text-brand', active);
          num.classList.toggle('text-zinc-400', !active);
          lab.classList.toggle('text-black', active);
          lab.classList.toggle('not-italic', active);
          lab.classList.toggle('underline', active);
          lab.classList.toggle('decoration-brand', active);
          lab.classList.toggle('decoration-2', active);
          lab.classList.toggle('underline-offset-4', active);
          lab.classList.toggle('italic', !active);
          lab.classList.toggle('text-zinc-400', !active);
        });
      };

      if ('IntersectionObserver' in window) {
        var current = null;
        var visible = new Map();
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(e) {
            if (e.isIntersecting) visible.set(e.target.id, e.target);
            else visible.delete(e.target.id);
          });
          var firstVisibleId = null;
          tocHeadings.forEach(function(h) {
            if (firstVisibleId === null && visible.has(h.id)) firstVisibleId = h.id;
          });
          if (firstVisibleId && firstVisibleId !== current) {
            current = firstVisibleId;
            setActive(current);
          }
        }, { rootMargin: '-15% 0px -70% 0px' });
        tocHeadings.forEach(function(h) { io.observe(h); });
      }

      links.forEach(function(link) {
        link.addEventListener('click', function(e) {
          var id = link.dataset.toc;
          var target = document.getElementById(id);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.replaceState(null, '', '#' + id);
          }
        });
      });
    }
  }

  document.addEventListener('click', function(e) {
    var coupon = e.target.closest('[data-copy-coupon]');
    if (coupon) {
      var code = coupon.dataset.copyCoupon;
      var label = coupon.querySelector('[data-coupon-text]') || coupon;
      var original = label.textContent;
      var copied = coupon.dataset.copiedLabel || original;
      var show = function() {
        label.textContent = copied;
        setTimeout(function() { label.textContent = original; }, 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(show).catch(show);
      } else {
        var ta = document.createElement('textarea');
        ta.value = code; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); show(); } catch(_) {}
        document.body.removeChild(ta);
      }
      return;
    }

    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    e.preventDefault();
    var type = btn.dataset.share;
    var url = location.href;
    var title = document.title;
    var image = (btn.closest('[data-share-group]') || {}).dataset
      ? (btn.closest('[data-share-group]').dataset.shareImage || '') : '';
    var enc = encodeURIComponent;

    if (type === 'copy') {
      var done = function() {
        btn.classList.add('text-green-600');
        setTimeout(function() { btn.classList.remove('text-green-600'); }, 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = url; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch(_) {}
        document.body.removeChild(ta);
      }
      return;
    }

    if (type === 'native') {
      if (navigator.share) { navigator.share({ url: url, title: title }); return; }
    }

    var targets = {
      facebook:  'https://www.facebook.com/sharer/sharer.php?u=' + enc(url),
      messenger: 'fb-messenger://share?link=' + enc(url),
      telegram:  'https://t.me/share/url?url=' + enc(url) + '&text=' + enc(title),
      pinterest: 'https://pinterest.com/pin/create/button/?url=' + enc(url) + '&media=' + enc(image) + '&description=' + enc(title)
    };

    if (type === 'messenger' && !/Android|iPhone|iPad/i.test(navigator.userAgent)) {
      targets.messenger = 'https://www.facebook.com/dialog/send?app_id=140586622674265&link=' + enc(url) + '&redirect_uri=' + enc(url);
    }

    var target = targets[type];
    if (target)
      window.open(target, '_blank', 'noopener,noreferrer,width=600,height=600');
  });

  function move(event) {
    _('#' + event.target.dataset.toc).scrollIntoView();
  }

function youtubeShow(event, youtube) {
  event.preventDefault();
  event.stopPropagation();
  var $parent = _('#yt-video-wrap').html('');
  _('div').appendTo($parent).attr('class', 'youtube-modal-content').append(
    _('iframe').attr(
      'allow', 'autoplay;fullscreen',
      'allowfullscreen', true,
      'frameborder', 0,
      'src', 'https://www.youtube-nocookie.com/embed/' + youtube + '?autoplay=1',
      'class', 'w-full aspect-video block'
    )
  );
}

})();